import { Box, CircularProgress, Divider, Typography } from '@mui/material';
import { FormikConfig } from 'formik';
import React from 'react';
import FilterComponentV2 from '../../../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import { confirmBank } from '../../../lib/fetchers';
import { eliminateOjectNotTruthyValues } from '../../../lib/helperFuncs';
import { confirmBankFields } from '../../../lib/static/filters/filterFields';
import { confirmBanlIinitialValues } from '../../../lib/static/filters/initialValues';
import { confirmBankValidationSchema } from '../../../lib/static/filters/ValidationSchema';
import Theme from '../../../Themes/main.theme';

const ConfirmBank = () => {
  const [data, setData] = React.useState<any>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();

  const onSubmit = async (values: FormikConfig<any>) => {
    setIsLoading(true);
    try {
      const response = await confirmBank(eliminateOjectNotTruthyValues(values));
      setError('');
      setData(response.data);
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };

  return (
    <>
      <Typography sx={{my: 2}} variant='h2'
        color={Theme?.labelColor?.main}>Διασταύρωση IBAN - ΑΦΜ από Τράπεζες</Typography>
      <FilterComponentV2
        title='Φίλτρα Αναζήτησης Στοιχείων IBAN- ΑΦΜ'
        validationSchema={confirmBankValidationSchema}
        filterFields={confirmBankFields}
        initialValues={confirmBanlIinitialValues}
        resetFilters={true}
        changeFilters={filterValues => onSubmit(filterValues)}
        validateOnBlur={false}
      />
      <Box mt={5} sx={{ display: 'flex', justifyContent: 'center'}}>
        {isLoading
          ? <CircularProgress />
          : error
            ? <Typography variant='h4'>
              {error}
            </Typography> 
            : data
              ? <Box display='flex' flexDirection='column'>
                {data.confirmed === '1'
                  ? <Box display='flex' justifyContent='center'>
                    <Typography >Η Διασταύρωση IBAN - ΑΦΜ:</Typography>
                    <Typography variant='h4'>Ήταν Επιτυχημένη</Typography>
                  </Box> 
                  : <Box>
                    <Typography>Η Διασταύρωση IBAN - ΑΦΜ:</Typography>
                    <Typography variant='h4'> ΔΕΝ ήταν Επιτυχημένη</Typography>
                  </Box> 
                }
                <Divider sx={{ my: 2}}/>
                <Typography>Ο έλεγχος έγινε για Τράπεζα: {data.bank}</Typography>
              </Box> 
              : null 
        }
      </Box>
    </>
  );
};

export default ConfirmBank;